import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Col,
  Row,
  message,
  Button,
  Select,
  Card,
  Modal,
} from "antd";
import { API_METHODS } from "../../constants";
import useApi from "../../hooks/useApi";
import { useNavigate } from "react-router-dom";

function Grievance() {
  const [messageApi, contextHolder] = message.useMessage();
  const [location, setLocation] = useState(null);
  const [hasSentGrievance, setHasSentGrievance] = useState(false);
  const [isLocationPermissionDenied, setIsLocationPermissionDenied] =
    useState(false);

  const [form] = Form.useForm();
  const [response, request] = useApi(
    "/website/grievance",
    null,
    API_METHODS.POST
  );
  const navigate = useNavigate();

  const [subjects, setSubjects] = useState([]);
  const [subjectResponse, subjectRequest] = useApi(
    "/website/grievance/subject",
    null,
    API_METHODS.GET
  );

  useEffect(() => {
    subjectRequest();
  }, []);

  useEffect(() => {
    if (subjectResponse.data) {
      setSubjects(subjectResponse.data);
    }
  }, [subjectResponse]);

  useEffect(() => {
    if (response.data) {
      messageApi.open({
        type: "success",
        content: "Grievance sent successfully.",
      });
      navigate("/");
    }
  }, [response]);

  const getLocation = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy: position.coords.accuracy,
        });
      },
      (err) => {
        if (err.code === err.PERMISSION_DENIED) {
          setIsLocationPermissionDenied(true);
        } else {
          messageApi.open({
            type: "error",
            content: "Location could not be determined.",
          });
        }
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  };

  const handleContinueWithoutLocation = () => {
    setIsLocationPermissionDenied(false);
    form
      .validateFields()
      .then((values) => {
        request(values);
      })
      .catch((e) => {});
  };

  const handleGoBackAndAllowLocation = () => {
    setIsLocationPermissionDenied(false);
  };

  const submit = () => {
    getLocation();
  };

  useEffect(() => {
    if (location && !hasSentGrievance) {
      setHasSentGrievance(true);
      form
        .validateFields()
        .then((values) => {
          values.latitude = location.latitude;
          values.longitude = location.longitude;
          values.accuracy = location.accuracy;
          request(values);
        })
        .catch((e) => {});
    }
  }, [location, form, request]);

  return (
    <Card title="स्त्री भ्रूण हत्या / गर्भलिंगनिदान / बाल विवाह तक्रार निवारण">
      {contextHolder}

      {/* Modal to inform user about location permission */}
      <Modal
        title="Location Permission Required"
        open={isLocationPermissionDenied}
        onCancel={() => setIsLocationPermissionDenied(false)} // Allow closing the modal
        footer={[
          <Button key="back" onClick={handleGoBackAndAllowLocation}>
            Go Back & Allow Location
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={handleContinueWithoutLocation}
          >
            Continue Without Location
          </Button>,
        ]}
      >
        <p>
          तक्रारी संदर्भातील अधिक माहितीसाठी तुमचे location आम्हास उपयुक्त ठरते.
        </p>
        <p>
          तुमचे location आम्हास देण्यासाठी browser मधून location access सुरू
          करा. Go Back & Allow Location बटणाचा वापर करा.
        </p>
        <p>
          लोकेशनशिवाय तक्रार करण्यासाठी आपले प्राधान्य असल्यास "Continue Without
          Location" बटणाचा वापर करा.
        </p>
      </Modal>

      <Form layout="vertical" form={form} onFinish={submit}>
        <Row gutter={16}>
          <Col xl={8} lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              name="grievance_subject_id"
              label="तक्रारीचे स्वरूप"
              rules={[{ required: true, message: "तक्रारीचे स्वरूप" }]}
            >
              <Select
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {subjects?.map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.subject}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              name="village"
              label="तक्रार ज्या गावातील आहे त्या गावाचे नाव"
              rules={[{ required: true, message: "गावाचे नाव." }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              name="text"
              label="तक्रारीचा तपशील (थोडक्यात)"
              rules={[
                {
                  required: true,
                  message: "तक्रारीचा तपशील थोडक्यात.",
                },
              ]}
            >
              <Input maxLength={100} />
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              name="against_name"
              label="कोणाविरुद्ध तक्रार आहे त्याचे नाव"
            >
              <Input />
            </Form.Item>
          </Col>

          <Col xl={8} lg={8} md={12} sm={24} xs={24}>
            <Form.Item name="name" label="तक्रारदाराचे नाव">
              <Input />
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={12} sm={24} xs={24}>
            <Form.Item name="mobile" label="तक्रारदाराचा संपर्क क्र.">
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <>तक्रारदाराचे नाव आणि संपर्क क्रमांक गोपनीय ठेवणेत येईल</>
        <Row justify="end">
          <Form.Item label={null}>
            <Button size="large" type="primary" htmlType="submit">
              नोंद करा
            </Button>
          </Form.Item>
        </Row>
      </Form>
    </Card>
  );
}

export default Grievance;
